import { render } from "./PictureModal.vue?vue&type=template&id=4d692f54&scoped=true"
import script from "./PictureModal.vue?vue&type=script&lang=ts"
export * from "./PictureModal.vue?vue&type=script&lang=ts"

import "./PictureModal.vue?vue&type=style&index=0&id=4d692f54&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4d692f54"

export default script